/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import PropTypes from 'prop-types';
export default function IconArrowDown({ className }){
  return(
    <svg className={className} fill="none" height="8" viewBox="0 0 14 8" width="14" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L7 7L13 1" stroke="#25282B" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
    </svg>
  );
}
IconArrowDown.propTypes = {
  className: PropTypes.string
};
